module.exports = __webpack_public_path__ + "img/solution-pc-3.b5b47a36.png";